import { render, staticRenderFns } from "./PageNotFound.vue?vue&type=template&id=c78d7b50&scoped=true&"
import script from "./PageNotFound.vue?vue&type=script&lang=js&"
export * from "./PageNotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c78d7b50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c78d7b50')) {
      api.createRecord('c78d7b50', component.options)
    } else {
      api.reload('c78d7b50', component.options)
    }
    module.hot.accept("./PageNotFound.vue?vue&type=template&id=c78d7b50&scoped=true&", function () {
      api.rerender('c78d7b50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PageNotFound.vue"
export default component.exports